import {
	createFileRoute,
	Outlet,
	useParams,
	useRouterState,
} from "@tanstack/react-router";
import { RecordWorkspaceAssetsTable } from "@/features/records/components";
import { isNestedAssetUnderRecordWorkspacePath } from "@/features/records/lib/is-nested-asset-under-record-workspace-path.util";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/records/(record)/$recordId/workspace/assets",
)({
	component: RecordWorkspaceAssetsTab,
	validateSearch: (search: Record<string, unknown>) => ({
		q: typeof search.q === "string" ? search.q : undefined,
	}),
});

/**
 * Org record workspace Assets tab — table shell with outlet for asset drawer /
 * nested workspace.
 */
function RecordWorkspaceAssetsTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/records/(record)/$recordId/workspace/assets",
	});
	const pathname = useRouterState({
		select: (state) => state.location.pathname,
	});

	if (isNestedAssetUnderRecordWorkspacePath(pathname)) {
		return <Outlet />;
	}

	return (
		<div className="relative flex min-h-0 w-full flex-1 flex-col">
			<RecordWorkspaceAssetsTable
				orgId={params.orgId}
				recordId={params.recordId}
			/>
			<Outlet />
		</div>
	);
}
